/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityRef
 */
export interface IdentityRef {
    /**
     * 
     * @type {string}
     * @memberof IdentityRef
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityRef
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityRef
     */
    companyId?: string;
}

/**
 * Check if a given object implements the IdentityRef interface.
 */
export function instanceOfIdentityRef(value: object): value is IdentityRef {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    return true;
}

export function IdentityRefFromJSON(json: any): IdentityRef {
    return IdentityRefFromJSONTyped(json, false);
}

export function IdentityRefFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityRef {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'identityId': json['identityId'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
    };
}

export function IdentityRefToJSON(value?: IdentityRef | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'identityId': value['identityId'],
        'companyId': value['companyId'],
    };
}

